import { render } from "./CurrentDiag.vue?vue&type=template&id=ebc74410&scoped=true"
import script from "./CurrentDiag.vue?vue&type=script&lang=js"
export * from "./CurrentDiag.vue?vue&type=script&lang=js"

import "./CurrentDiag.vue?vue&type=style&index=0&id=ebc74410&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc74410"]])

export default __exports__